import Skeleton from "react-loading-skeleton";

const LinkAddDialogSkeleton = () => {
  return (
    <>
      <div className="h-4 w-4 flex-shrink-0 rounded-[5px] bg-[#3E4042]" />
      <div className="flex h-6 flex-1 items-center rounded-[5px] bg-[#232425]">
        <Skeleton
          width={274}
          height={16}
          baseColor="#3E4042"
          highlightColor="#656668"
          borderRadius={4}
        />
      </div>
    </>
  );
};

export default LinkAddDialogSkeleton;
